export const Color = {
  primary: "#f4f4f4",
  white: "#FFFFFF",
  darkOrange: "#f7931e",
  headingColor: "#f7931e",
  subHeading: "#333",
  textColor: "#666",
  black: "#000000",
  blueGray: "blue-gray",
} as const;
